import { ColorNeutralDarkGrey, FontSize10, Spacing4 } from 'autogen/design-tokens/tokens';
import dynamic from 'helpers/dynamic';
import React from 'react';
import styled from 'styled-components';
import useSponsoredSplashQuickView from './hooks/useSponsoredSplashQuickView';
import { useTranslation } from 'react-i18next';
import { Sponsored } from 'autogen/translation-keys/trans-website-productlists-labels';
import { Info } from 'autogen/translation-keys/trans-website-imagealttext-icons';
import InlineButton from 'components/generic/InlineButton';

type SponsoredSplashProps = {
    productId?: number;
};

const Container = styled.div`
    display: flex;
    gap: ${Spacing4};
    justify-content: flex-start;
    align-items: center;
`;

const Label = styled.div`
    font-size: ${FontSize10};
    color: ${ColorNeutralDarkGrey};
`;

const InfoCircle = styled(dynamic(() => import('icons/Info.svg?react')))`
    cursor: pointer;

    path {
        fill: ${ColorNeutralDarkGrey};
    }
`;

export default function SponsoredSplash({ productId, ...restProps }: SponsoredSplashProps): JSX.Element {
    const [, toggle] = useSponsoredSplashQuickView();
    const { t } = useTranslation();

    return (
        <Container {...restProps}>
            <Label>{t(Sponsored)}</Label>
            <InlineButton
                onClick={() =>
                    toggle({
                        isOpen: true,
                        productId: productId
                    })
                }
                aria-label={`${t(Sponsored)} ${t(Info)}`}
            >
                <InfoCircle width={16} height={16} />
            </InlineButton>
        </Container>
    );
}
